module.exports = __webpack_public_path__ + "img/Chart.db4bf2e2.svg";